import React from "react";
import { StyledButton, StyledIcon } from "../../styled/CallButton";

const CallButton = ({
  disabled,
  action,
  src,
  usarIconoEnBlanco,
  leaveRoomButton,
}) => {
  return (
    <StyledButton
      aria-haspopup="true"
      onClick={action}
      disabled={disabled}
      variant="outlined"
      isLastButton={leaveRoomButton}>
      <StyledIcon as={src.type.type} usarIconoEnBlanco={usarIconoEnBlanco} />
    </StyledButton>
  );
};

export default CallButton;
